// What `/<role>/home` draws. The route is one for all roles; this picks the page.
//
// The System Administrator's Acasă IS the reports register (owner decision
// Q-1-01, 2026-10-13; the wireframe's own choice): `/system-admin/home` forwards
// to `/system-admin/reports` and draws nothing of its own, so there is one page
// for the role to land on, to be sent back to by the guard, and to see in the
// menu under Acasă. The location state rides along, because the guard's notice
// («Nu ai acces…») is printed by the page the reader arrives on.
// per docs/shape-ops-system-admin-home.md §Decision
import { Navigate, useLocation } from 'react-router-dom';
import { OperatorHome } from '../pages/operator/OperatorHome';
import { RegistrarAdminHome } from '../pages/registrar-admin/RegistrarAdminHome';
import { ObserverHome } from '../pages/observer/ObserverHome';
import { UnknownAddress } from './route-guard/UnknownAddress';

export const SYSTEM_ADMIN_HOME_TARGET = '/system-admin/reports';

export function RoleHomeDispatcher(): JSX.Element {
  const { pathname, state } = useLocation();
  if (pathname.startsWith('/operator')) return <OperatorHome />;
  if (pathname.startsWith('/system-admin')) {
    return <Navigate to={SYSTEM_ADMIN_HOME_TARGET} replace state={state} />;
  }
  if (pathname.startsWith('/registrar-admin')) return <RegistrarAdminHome />;
  if (pathname.startsWith('/observer')) return <ObserverHome />;
  // Unreachable behind the guard, which refuses a role segment the session does
  // not hold; kept total rather than drawing a stub.
  return <UnknownAddress />;
}
